"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DailyBankingServiceErrorCode = exports.SeizureStatus = void 0;
var SeizureStatus;
(function (SeizureStatus) {
    SeizureStatus["ACTIVE"] = "ACTIVE";
    SeizureStatus["PAID"] = "PAID";
    SeizureStatus["CANCELLED"] = "CANCELLED";
})(SeizureStatus || (exports.SeizureStatus = SeizureStatus = {}));
var DailyBankingServiceErrorCode;
(function (DailyBankingServiceErrorCode) {
    DailyBankingServiceErrorCode["SEIZURE_NOT_FOUND"] = "error.seizure.not.found";
})(DailyBankingServiceErrorCode || (exports.DailyBankingServiceErrorCode = DailyBankingServiceErrorCode = {}));
